export default __webpack_public_path__ + "images/TL.80f7161.png";